export default __webpack_public_path__ + "static/media/480_business03-nl-mobile.f4f91f16.png";